export const BUDGET_OPTIONS = [
  { value: '7000', label: 'Above $7,000' },
  { value: '6000', label: '$5,000 - $7,000' },
  { value: '4000', label: '$3,000 - $5,000' },
  { value: '2500', label: '$2,000 - $3,000' },
  { value: '1750', label: 'Below $2,000' },
] as const

export type BudgetOption = typeof BUDGET_OPTIONS[number]['value']
